"use client";
import React from "react";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v13-appRouter";
import { AuthProvider } from "../util/auth";
import { ThemeProvider } from "../styles/theme";
import { WebcamProvider } from "./contexts/WebcamContext";
import { isFeagiEmbodimentIntegrationEnabled } from "../util/feagiEmbodimentIntegration";
import AdminPendingWorkProvider from "../components/admin/AdminPendingWorkProvider";
import AdminSessionBootstrap from "../components/auth/AdminSessionBootstrap";

export function Providers({ children }: { children: React.ReactNode }) {
  const feagiEmbodiment = isFeagiEmbodimentIntegrationEnabled();
  return (
    <AppRouterCacheProvider>
      <AuthProvider>
        <AdminSessionBootstrap />
        <ThemeProvider>
          <AdminPendingWorkProvider>
            {feagiEmbodiment ? (
              <WebcamProvider>{children}</WebcamProvider>
            ) : (
              children
            )}
          </AdminPendingWorkProvider>
        </ThemeProvider>
      </AuthProvider>
    </AppRouterCacheProvider>
  );
}
